"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeHandlerDefinitionAdapter_1 = require("./NodeHandlerDefinitionAdapter");
/**
 * Errors if fragment definitions are found,
 * as these should have been processed away earlier.
 */


var NodeHandlerDefinitionFragment =
/*#__PURE__*/
function (_NodeHandlerDefinitio) {
  _inherits(NodeHandlerDefinitionFragment, _NodeHandlerDefinitio);

  function NodeHandlerDefinitionFragment(util, settings) {
    _classCallCheck(this, NodeHandlerDefinitionFragment);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeHandlerDefinitionFragment).call(this, 'FragmentDefinition', util, settings));
  }

  _createClass(NodeHandlerDefinitionFragment, [{
    key: "handle",
    value: function handle(operationDefinition, convertContext) {
      throw new Error('Illegal state: fragment definitions must be indexed and removed before processing');
    }
  }]);

  return NodeHandlerDefinitionFragment;
}(NodeHandlerDefinitionAdapter_1.NodeHandlerDefinitionAdapter);

exports.NodeHandlerDefinitionFragment = NodeHandlerDefinitionFragment;